import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { UserGeoTrackDto } from "../models/User/user-geo-track.dto";
import { GetUsersGeoTracksRequest } from "../models/User/get-users-geo-tracks.request";

@Injectable()
export class GeoService extends DataService<any, any> {
    constructor(
        http: HttpClient,
        notificationService: NotificationService,) {
        super(http, notificationService);
        this.controllerName = 'geo';
    }

    public getUsersGeoTracks(request: GetUsersGeoTracksRequest): Observable<ActionDataResult<UserGeoTrackDto[]>> {
        return this.postQuery<UserGeoTrackDto[]>(`${this.baseUrl()}/get-users-geo-tracks`, request);
    }
}